import React, { createContext, useCallback, useContext, useState } from "react";

export const ActionListContext = createContext({});

export const ActionListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      companies: [],
      actionStatus: [],
      responsible: undefined,
      requester: undefined,
      directorship: undefined,
      kind: undefined,
      committee: undefined,
      meetStartDate: null,
      meetEndDate: null,
      deadlineStartDate: null,
      deadlineEndDate: null,
      keyWord: undefined,
      actionNumber: undefined,
      chairpersonValidation: undefined,
      focalPoint: undefined,
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      filterParams: params,
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      pagination: paginationOption,
    }));
  }, []);

  return (
    <ActionListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </ActionListContext.Provider>
  );
};

export function useActionList() {
  const context = useContext(ActionListContext);

  if (!context) {
    throw new Error("useActionList must be used within an ActionListProvider.");
  }

  return context;
}
